import React from "react";
import { CollapseFAQ, H3, NamedLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';

import ContinueIcon from '../../TopbarContainer/Topbar/images/continue-icon.svg';
import RabbitImage from '../images/diana-macesanu SMALL RABBIT.jpg';

import css from '../PetSittingServicesPage.module.css';
import { rabbitFaq } from "./faqs";


const RabbitPage = props => {
    return (
        <div className={css.rootOld}>
            <H3>
                Rabbit Sitting Services
            </H3>

            <p className={css.info}>
                HouseSit Match is the trusted platform for rabbit sitting services, connecting owners with reliable and caring sitters. Whether you're traveling or need an extra hand, our verified sitters ensure your rabbits are well-cared for in the comfort of their home. For sitters, it's an opportunity to support pet owners while gaining rewarding experiences with these gentle and intelligent animals.
            </p>

            <NamedLink
                className={css.ctaButtonOld}
                name="SignupPage"
            >
                <FormattedMessage id="PetSittingServicesPage.registerNow" />
                <img src={ContinueIcon} className={css.icon} />
            </NamedLink>

            <p className={css.subtitle}>
                What Is Rabbit Sitting?
            </p>

            <div className={css.imageContainer}>
                <img className={css.image} src={RabbitImage} alt='travel is one of the benefits of house sitting for sitters' />
                <p className={css.info}>Photo by Diana Măceşanu</p>
            </div>
            <br />
            <p className={css.info}>
                Rabbit sitting is a type of pet sitting that involves providing attentive care for rabbits in their home environment while the owner is away. This includes feeding, cleaning, and offering companionship tailored to each rabbit's needs. Sitters not only help ensure a rabbit's routine is maintained but also provide peace of mind for owners, knowing their pet is in safe and experienced hands.
            </p>

            <p className={css.subtitle}>
                Why Choose HouseSit Match for Rabbit Sitting?
            </p>

            <p className={css.info}>
                HouseSit Match simplifies the process of finding or becoming a rabbit sitter with features designed to ensure trust, quality, and convenience.
            </p>

            <ul className={css.list}>
                <li>
                    <strong>Verified Sitters: </strong>
                    All sitters undergo verification, ensuring reliable and trustworthy matches for your peace of mind.
                </li>
                <li>
                    <strong>Tailored Care: </strong>
                    Sitters with small animal experience provide personalised care to keep rabbits happy and healthy.
                </li>
                <li>
                    <strong>Affordable Solution: </strong>
                    With a membership model, enjoy high-quality care without extra fees for sitting arrangements.
                </li>
                <li>
                    <strong>Global Community: </strong>
                    Connect with a network of animal lovers who share your passion for providing exceptional pet care.
                </li>
                <li>
                    <strong>Support for Pet Charities: </strong>
                    A portion of every membership fee goes toward supporting animal welfare organisations.
                </li>
            </ul>

            <p className={css.subtitle}>
                The Benefits of Rabbit Sitting
            </p>
            <p className={css.info}>
                Rabbit sitting offers advantages for owners, sitters, and rabbits:
            </p>

            <ul className={css.list}>
                <li>
                    <strong>Stress-Free for Rabbits: </strong>
                    Care in their home prevents the anxiety of unfamiliar environments.
                </li>
                <li>
                    <strong>Personalised Attention: </strong>
                    Routines, dietary needs, and preferences are prioritised.
                </li>
                <li>
                    <strong>Affordable for Owners: </strong>
                    Cost-effective compared to rabbit boarding options.
                </li>
                <li>
                    <strong>Fulfilling for Sitters: </strong>
                    Gain valuable experience and build lasting connections.
                </li>
                <li>
                    <strong>Peace of Mind: </strong>
                    Owners can trust their rabbits are in responsible, loving hands.
                </li>
            </ul>

            <p className={css.subtitle}>
                Costs Associated with Rabbit Sitting
            </p>
            <p className={css.info}>
                Rabbit sitting through HouseSit Match operates on a unique exchange model. Owners pay only a membership fee to access our network of trusted rabbit sitters, while sitters gain free accommodation in return for their care. This makes it a cost-effective alternative to expensive boarding services, like rabbit hotels, which often lack the personal touch your pet deserves. With HouseSit Match, you secure tailored, one-on-one care for your rabbit without any additional sitting fees—keeping both your pet and your budget happy.
            </p>

            <p className={css.subtitle}>
                What Does a Rabbit Sitter Do?
            </p>
            <p className={css.info}>
                Rabbit sitters handle essential tasks to keep rabbits happy and healthy:
            </p>

            <ul className={css.listNumbers}>
                <li>
                    Follow feeding schedules and dietary preferences.
                </li>
                <li>
                    Maintain clean enclosures and living spaces.
                </li>
                <li>
                    Monitor health and behaviour for signs of stress or illness.
                </li>
                <li>
                    Provide companionship through playtime and gentle interaction.
                </li>
                <li>
                    Follow specific care instructions provided by the owner.
                </li>
            </ul>

            <p className={css.subtitle}>
                How to Become a Rabbit Sitter
            </p>

            <p className={css.info}>
                Becoming a rabbit sitter is easy on HouseSit Match with these simple steps:
            </p>

            <ul className={css.listNumbers}>
                <li>
                    <strong>Sign Up on Our Platform: </strong>
                    Create a profile showcasing your love for animals and any relevant experience.
                </li>
                <li>
                    <strong>Complete Verification:</strong>
                    Pass our background checks to become a trusted sitter.
                </li>
                <li>
                    <strong>Connect with Owners: </strong>
                    Apply for rabbit sitting opportunities tailored to your availability.
                </li>
                <li>
                    <strong>Deliver Exceptional Care: </strong>
                    Build trust with owners and gain testimonials to grow your profile.
                </li>
            </ul>

            <p className={css.subtitle}>
                Testimonials
            </p>

            <p className={css.info}>
                Example testimonials here
            </p>

            <p className={css.subtitle} style={{ marginBottom: 0 }}>
                FAQs About Rabbit Sitting
            </p>

            <CollapseFAQ
                list={rabbitFaq}
            />

            <p className={css.subtitle}>
                Go the Extra Mile for Your Rabbit
            </p>

            <p className={css.info}>
                Whether you're a rabbit owner or a sitter, HouseSit Match provides the tools and connections you need for stress-free rabbit care. Our platform ensures every match is built on trust and shared understanding.
            </p>
            <br />
            <p className={css.info}>
                <NamedLink name="SignupPage">Sign up today</NamedLink> to find your perfect sitter or take the first step toward becoming a trusted sitter yourself. Join HouseSit Match and make rabbit care simple, reliable, and rewarding.
            </p>

            <NamedLink
                className={css.ctaButtonOld}
                name="SignupPage"
            >
                <FormattedMessage id="PetSittingServicesPage.registerNow" />
                <img src={ContinueIcon} className={css.icon} />
            </NamedLink>
        </div>
    )
};

export default RabbitPage;